import React from "react";

const reasons = [
  {
    icon: "fa-shield-halved",
    title: "Vetted Experts Only",
    desc: "Every advisor is screened on track record, ethics and outcomes.",
  },
  {
    icon: "fa-bolt",
    title: "WhatsApp-first Access",
    desc: "Talk to us instantly — no portals, no waiting rooms.",
  },
  {
    icon: "fa-handshake",
    title: "Founder-aligned Pricing",
    desc: "Flat, transparent fees. No surprise invoices or padded retainers.",
  },
  {
    icon: "fa-globe-africa",
    title: "Pan-India Network",
    desc: "Expertise across Tier 1, 2 & 3 cities and 14+ industries.",
  },
  {
    icon: "fa-medal",
    title: "Outcome-driven",
    desc: "We measure success by your revenue, funding & operational lift.",
  },
];

const WhyChoose = () => {
  return (
    <section
      className="relative py-20 sm:py-28 overflow-hidden"
      data-testid="why-choose-section"
    >
      <div className="absolute inset-0 -z-10 bg-ibh-navy"></div>
      <div className="absolute inset-0 -z-10 grain opacity-100 mix-blend-overlay"></div>
      <div className="absolute -top-32 -left-32 h-96 w-96 rounded-full bg-ibh-green/20 blur-3xl"></div>
      <div className="absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-ibh-orange/20 blur-3xl"></div>

      <div className="section grid lg:grid-cols-12 gap-12 items-center relative">
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/40 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em]" style={{color: "#36454F"}}>
  <i className="fa-solid fa-fire text-amber-300"></i>
  Why IBH
</span>
          <h2 className="mt-5 font-display text-3xl sm:text-5xl font-bold text-slate-900">
            Built for India's <br className="hidden sm:block" />
            <span className="gradient-text">next 10 million businesses.</span>
          </h2>
          <p className="mt-5 max-w-xl" style={{color: "#36454F"}}>
            We don't sell consulting hours. We commit to outcomes — every plan,
            every expert, every conversation is structured around your growth.
          </p>

          <ul className="mt-10 grid sm:grid-cols-2 gap-4">
            {reasons.map((r, i) => (
              <li
                key={r.title}
                className="flex gap-3 rounded-2xl bg-white/5 border border-white/10 p-4 hover:bg-white/10 transition-colors"
                data-testid={`why-reason-${i}`}
              >
                <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-ibh-green to-emerald-400 flex items-center justify-center text-white shrink-0">
                  <i className={`fa-solid ${r.icon}`}></i>
                </div>
                <div>
                  <p className="font-display font-bold" style={{color: "#36454F"}}>{r.title}</p>
                  <p className="text-sm mt-0.5" style={{color: "#36454F"}}>{r.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-5 flex justify-center">
          <div
            className="relative h-72 w-72 sm:h-80 sm:w-80"
            data-testid="commitment-stat"
          >
            <svg
              viewBox="0 0 200 200"
              className="absolute inset-0 -rotate-90"
            >
              <defs>
                <linearGradient id="ringGrad" x1="0" x2="1" y1="0" y2="1">
                  <stop offset="0%" stopColor="#F97316" />
                  <stop offset="50%" stopColor="#A855F7" />
                  <stop offset="100%" stopColor="#16A34A" />
                </linearGradient>
              </defs>
              <circle
                cx="100"
                cy="100"
                r="86"
                fill="none"
                stroke="rgba(255,255,255,0.08)"
                strokeWidth="14"
              />
              <circle
                cx="100"
                cy="100"
                r="86"
                fill="none"
                stroke="url(#ringGrad)"
                strokeWidth="14"
                strokeLinecap="round"
                strokeDasharray="540"
                strokeDashoffset="0"
              />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
              <span className="text-xs uppercase tracking-[0.25em]" style={{color: "#36454F"}}>
    Commitment
             </span>
            <span className="font-display text-6xl font-bold mt-2" style={{color: "#36454F"}}>
    100%
             </span>
              <span className="mt-2 text-sm max-w-[180px]" style={{color: "#36454F"}}>
    To founders, MSMEs & Indian enterprise
             </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
